export default {"src":"/_next/static/media/hat.de728fcc.svg","height":270,"width":400,"blurWidth":0,"blurHeight":0};